import React, { useState, useEffect, useRef } from "react";

const Selector = ({ 
  options = [], 
  value, 
  onChange, 
  name="",
  placeholder = "" 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (selectedValue) => {
    onChange(selectedValue,name);
    setIsOpen(false);
  };

  return (
    <div className="relative w-full z--1" ref={dropdownRef}>
      <div
        className="relative border-b-2 border-gray-300 p-2 cursor-pointer flex justify-between items-center z--1"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{value ? options.find(opt => opt.value === value)?.label : placeholder}</span>
        <span className="text-gray-500">&#9662;</span> {/* Dropdown Arrow */}
      </div>

      {isOpen && (
        <div className="absolute left-0 w-full mt-2 bg-white border rounded shadow-lg max-h-60 overflow-auto z--1">
          {options.map((option) => (
            <div
              key={option.value}
              className="px-4 py-2 cursor-pointer hover:bg-blue-100 z--1"
              onClick={() => handleSelect(option.value)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Selector;